import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getTemplatesKey } from '../../utils/keys';
export const DefaultTemplatesLimit = 10;
export const useTemplates = (options) => {
    const { variables = { limit: DefaultTemplatesLimit }, fields = 'basic', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const templatesKey = getTemplatesKey({ variables, fields });
    return useInfiniteQuery(templatesKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.templates.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useTemplates.js.map